import http from '../../../Services/api.laravel.http';

export const ExpiryService = {
    getExpiry: (formParams) => http.post('/admin/expiry/search', formParams),
};
